import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
  
import * as XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFilePdf } from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";
import excelIcon from "../../assets/icons/excel.png";
import AppDataGrid from "../../components/common/AppDataGrid";

const Financedailyreport = () => {
  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [form, setForm] = useState({
    selected_date: ""
  });
  const [selectedFyId, setSelectedFyId] = useState(userObj.fy_id);

  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [reportData, setReportData] = useState({
    cash_inward: [],
    cash_outward: [],
    summary: {}
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  useEffect(() => {
    const fetchActiveFy = async () => {
      try {
        const response = await axios.post(`${baseUrl}/financialyearprocedure/`, {
          action: "READ",
          school_id: userObj.school_id
        });
        const activeYear = response.data.find(year => year.is_active);
        if (activeYear) {
          setSelectedFyId(activeYear.fy_id);
        }
      } catch (error) {
        console.error("Error fetching financial years:", error);
      }
    };
    fetchActiveFy();
  }, [baseUrl, userObj.school_id]);

  const fetchData = async () => {
    if (!form.selected_date) {
      toast.error("Please select a date");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(
        `${baseUrl}/daily_cash_book_report/`,
        {
          school_id: userObj.school_id,
          to_date: form.selected_date,
          fy_id: selectedFyId
        }
      );

      setReportData(response.data);

    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch report");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  // Calculate totals
const calculateTotals = () => {
  const query = searchQuery.toLowerCase();

  const matchItem = (item) => {
    return (
      item.transaction_details?.toLowerCase().includes(query) ||
      String(item.payment_mode || "").toLowerCase().includes(query) ||
      String(item.amount || "").toLowerCase().includes(query) ||
      String(item.date || "").toLowerCase().includes(query) ||
      String(item.reference_no || "").toLowerCase().includes(query) ||
      String(item.description || "").toLowerCase().includes(query)
    );
  };

  const cashInwardFiltered =
    reportData.cash_inward?.filter(matchItem) || [];

  const cashOutwardFiltered =
    reportData.cash_outward?.filter(matchItem) || [];

  const cashInwardTotal = cashInwardFiltered.reduce(
    (sum, item) => sum + (parseFloat(item.amount) || 0),
    0
  );

  const cashOutwardTotal = cashOutwardFiltered.reduce(
    (sum, item) => sum + (parseFloat(item.amount) || 0),
    0
  );

  return {
    cash_inward_total: cashInwardTotal,
    cash_outward_total: cashOutwardTotal,
    current_balance: reportData.summary?.current_balance || 0,
    cash_inward_filtered: cashInwardFiltered,
    cash_outward_filtered: cashOutwardFiltered,
  };
};
  const totals = calculateTotals();

  const formatParticulars = (text, prefix) => {
    if (!text) return "";
    let trimmed = text.trim();
    if (trimmed.toLowerCase().startsWith(prefix.toLowerCase() + " ")) return trimmed;
    if (trimmed.toLowerCase() === "total payments:" || trimmed.toLowerCase() === "total receipts:" || trimmed.toLowerCase() === "total expenses:" || trimmed.toLowerCase() === "total income:") return trimmed;
    return `${prefix} ${trimmed}`;
  };

  const exportToExcel = () => {
    if (!reportData.cash_inward?.length && !reportData.cash_outward?.length) {
      toast.error("No data available to export.");
      return;
    }

    const { cash_inward_filtered, cash_outward_filtered, cash_inward_total, cash_outward_total, current_balance } = totals;

    const maxRows = Math.max((cash_outward_filtered || []).length, (cash_inward_filtered || []).length);
    const excelData = [];

    excelData.push([userObj.school_name || "ST. ISAAC WELFARE SOCIETY"]);
    excelData.push(["#13-9-1/3/24, Radha Krishna Nagar, Borabanda, Hyderabad - 500018"]);
    excelData.push([""]);
    excelData.push(["DAILY CASH BOOK REPORT FOR " + form.selected_date]);
    excelData.push(["Particulars", "Mode", "Amount in Rupees", "Particulars", "Mode", "Amount in Rupees"]);

    for (let i = 0; i < maxRows; i++) {
      const outward = (cash_outward_filtered || [])[i];
      const inward = (cash_inward_filtered || [])[i];
      excelData.push([
        outward ? formatParticulars(outward.transaction_details, 'To') : "",
        outward ? (outward.payment_mode || "") : "",
        outward ? parseFloat(outward.amount) : "",
        inward ? formatParticulars(inward.transaction_details, 'By') : "",
        inward ? (inward.payment_mode || "") : "",
        inward ? parseFloat(inward.amount) : ""
      ]);
    }

    excelData.push([
      "Total Expenses:",
      "",
      cash_outward_total,
      "",
      "",
      ""
    ]);
    excelData.push([
      "Current Balance:",
      "",
      current_balance,
      "",
      "",
      ""
    ]);
    excelData.push([
      "Total",
      "",
      cash_outward_total + current_balance,
      "Total",
      "",
      cash_inward_total
    ]);

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(excelData);

    if (!ws["!merges"]) ws["!merges"] = [];
    for (let i = 0; i < 4; i++) {
      ws["!merges"].push({ s: { r: i, c: 0 }, e: { r: i, c: 5 } });
    }

    const titleSocietyStyle = {
      font: { bold: true, sz: 14 },
      alignment: { horizontal: "center", vertical: "center" }
    };

    const subtitleStyle = {
      font: { sz: 11 },
      alignment: { horizontal: "center", vertical: "center" }
    };

    const titleReportStyle = {
      font: { bold: true, sz: 12, underline: true },
      alignment: { horizontal: "center", vertical: "center" }
    };

    const headerStyle = {
      font: { bold: true },
      alignment: { horizontal: "center", vertical: "center" },
      border: { top: { style: "thin" }, bottom: { style: "thin" } }
    };

    const totalStyle = {
      font: { bold: true },
      border: { top: { style: "thin" }, bottom: { style: "thin" } }
    };

    const balanceStyle = {
      font: { bold: true }
    };

    const grandTotalStyle = {
      font: { bold: true },
      border: { top: { style: "thin" }, bottom: { style: "double" } }
    };

    const range = XLSX.utils.decode_range(ws["!ref"]);
    const titleRowIdx = 3;
    const headerRowIdx = 4;
    const totalRowIdx = 5 + maxRows;
    const balanceRowIdx = 6 + maxRows;
    const grandTotalRowIdx = 7 + maxRows;

    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;

        let baseStyle = {};
        if (R === 0) {
          baseStyle = titleSocietyStyle;
        } else if (R === 1 || R === 2) {
          baseStyle = subtitleStyle;
        } else if (R === titleRowIdx) {
          baseStyle = titleReportStyle;
        } else if (R === headerRowIdx) {
          baseStyle = headerStyle;
        } else if (R === totalRowIdx) {
          baseStyle = totalStyle;
        } else if (R === balanceRowIdx) {
          baseStyle = balanceStyle;
        } else if (R === grandTotalRowIdx) {
          baseStyle = grandTotalStyle;
        }

        const cellStyle = {};
        if (baseStyle.font) cellStyle.font = { ...baseStyle.font };
        if (baseStyle.alignment) cellStyle.alignment = { ...baseStyle.alignment };
        cellStyle.border = baseStyle.border ? { ...baseStyle.border } : {};

        if (R > headerRowIdx && C === 2) {
          cellStyle.border.right = { style: "thin" };
        }

        if (Object.keys(cellStyle.border).length === 0) {
          delete cellStyle.border;
        }

        ws[cellRef].s = cellStyle;

        if ((C === 2 || C === 5) && typeof ws[cellRef].v === 'number') {
          ws[cellRef].z = '#,##0.00';
        }
      }
    }

    ws["!cols"] = [{ wch: 30 }, { wch: 10 }, { wch: 15 }, { wch: 30 }, { wch: 10 }, { wch: 15 }];

    XLSX.utils.book_append_sheet(wb, ws, "Daily Cash Book");
    XLSX.writeFile(wb, `Daily_Cash_Book_${form.selected_date}.xlsx`);
  };

  const exportToPDF = async () => {
    if (!reportData.cash_inward?.length && !reportData.cash_outward?.length) {
      toast.error("No data available to export.");
      return;
    }

    const doc = new jsPDF("portrait");

    const pageWidth = doc.internal.pageSize.getWidth();

    // Add Logo
    if (userObj.logo) {
      const logoUrl = `${baseUrl}/uploads/get-image/${userObj.logo}`;
      const getBase64ImageFromURL = (url) => {
        return new Promise((resolve, reject) => {
          let img = new Image();
          img.setAttribute("crossOrigin", "anonymous");
          img.onload = () => {
            let canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            let ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            let dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
          };
          img.onerror = (error) => reject(error);
          img.src = url;
        });
      };

      try {
        const base64Img = await getBase64ImageFromURL(logoUrl);
        // Add image near top-left, dimensions 25x25
        doc.addImage(base64Img, "PNG", 14, 4, 25, 25);
      } catch (e) {
        console.warn("Could not load logo for PDF", e);
      }
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    const schoolName = userObj.school_name || "ST. ISAAC WELFARE SOCIETY";
    doc.text(schoolName, (pageWidth - doc.getTextWidth(schoolName)) / 2, 15);

    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    const branchName = userObj.branch || "#13-9-1/3/24, Radha Krishna Nagar, Borabanda, Hyderabad - 500018";
    doc.text(branchName, (pageWidth - doc.getTextWidth(branchName)) / 2, 22);

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    const { cash_inward_filtered, cash_outward_filtered, cash_inward_total, cash_outward_total, current_balance } = totals;
    const title = `DAILY CASH BOOK REPORT FOR ${form.selected_date}`;
    const textWidth = doc.getTextWidth(title);
    doc.text(title, (pageWidth - textWidth) / 2, 34);
    const maxRows = Math.max((cash_outward_filtered || []).length, (cash_inward_filtered || []).length);
    const tableData = [];

    for (let i = 0; i < maxRows; i++) {
      const outward = (cash_outward_filtered || [])[i];
      const inward = (cash_inward_filtered || [])[i];
      tableData.push([
        outward ? formatParticulars(outward.transaction_details, 'To') : "",
        outward ? (outward.payment_mode || "") : "",
        outward ? parseFloat(outward.amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "",
        inward ? formatParticulars(inward.transaction_details, 'By') : "",
        inward ? (inward.payment_mode || "") : "",
        inward ? parseFloat(inward.amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ""
      ]);
    }

    tableData.push([
      "Total Expenses:",
      "",
      cash_outward_total.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      "",
      "",
      ""
    ]);

    tableData.push([
      "Current Balance:",
      "",
      current_balance.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      "",
      "",
      ""
    ]);

    tableData.push([
      "Total:",
      "",
      (cash_outward_total + current_balance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      "Total:",
      "",
      cash_inward_total.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    ]);

    autoTable(doc, {
      head: [
        ["Particulars", "Mode", "Amount in Rupees", "Particulars", "Mode", "Amount in Rupees"]
      ],
      body: tableData,
      startY: 42,
      theme: 'plain',
      styles: { fontSize: 9, cellPadding: 2, textColor: 0 },
      headStyles: {
        fontStyle: 'bold',
        lineWidth: { top: 0.5, bottom: 0.5 },
        lineColor: 0,
        halign: 'center'
      },
      columnStyles: {
        2: { halign: 'right' },
        5: { halign: 'right' }
      },
      willDrawCell: function (data) {
        if (data.section === 'body') {
          const isTotalExpensesRow = data.row.index === tableData.length - 3;
          const isCurrentBalanceRow = data.row.index === tableData.length - 2;
          const isGrandTotalRow = data.row.index === tableData.length - 1;

          if (isTotalExpensesRow || isCurrentBalanceRow || isGrandTotalRow) {
            doc.setFont("helvetica", "bold");
          }

          doc.setDrawColor(0);
          doc.setLineWidth(0.5);

          if (isTotalExpensesRow) {
            doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y);
            doc.line(data.cell.x, data.cell.y + data.cell.height, data.cell.x + data.cell.width, data.cell.y + data.cell.height);
          } else if (isGrandTotalRow) {
            doc.line(data.cell.x, data.cell.y, data.cell.x + data.cell.width, data.cell.y);
            const yBottom = data.cell.y + data.cell.height;
            doc.line(data.cell.x, yBottom, data.cell.x + data.cell.width, yBottom);
            doc.line(data.cell.x, yBottom + 0.8, data.cell.x + data.cell.width, yBottom + 0.8);
          }
        }
      }
    });

    const fileName = `Daily_Cash_Book_${form.selected_date}.pdf`;
    doc.save(fileName);
  };

  const handleReset = () => {
    setForm({
      selected_date: "",
    });
    setReportData({
      cash_inward: [],
      cash_outward: [],
      summary: {}
    });
    setSearchQuery("");
  };

  const gridColumns = [
    {
      field: "outward_details",
      headerName: "Outward Particulars",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <span style={{ fontWeight: params.row.isTotal ? 'bold' : 'normal', backgroundColor: params.row.isTotal ? '#fff3cd' : 'transparent', height: '100%', width: '100%', display: 'flex', alignItems: 'center' }}>
          {params.value}
        </span>
      )
    },
    {
      field: "outward_mode",
      headerName: "Mode",
      width: 100,
      renderCell: (params) => (
        <span style={{ fontWeight: params.row.isTotal ? 'bold' : 'normal', backgroundColor: params.row.isTotal ? '#fff3cd' : 'transparent', height: '100%', width: '100%', display: 'flex', alignItems: 'center' }}>
          {params.value}
        </span>
      )
    },
    {
      field: "outward_amount",
      headerName: "Amount in Rupees",
      width: 130,
      align: "right",
      headerAlign: "right",
      renderCell: (params) => {
        const val = params.value;
        const displayVal = val !== "" && val != null 
          ? parseFloat(val).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : "";
        return (
          <span style={{ fontWeight: params.row.isTotal ? 'bold' : 'normal', backgroundColor: params.row.isTotal ? '#fff3cd' : 'transparent', height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            {displayVal}
          </span>
        );
      }
    },
    {
      field: "inward_details",
      headerName: "Inward Particulars",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <span style={{ fontWeight: params.row.isTotal ? 'bold' : 'normal', backgroundColor: params.row.isTotal ? '#fff3cd' : 'transparent', height: '100%', width: '100%', display: 'flex', alignItems: 'center' }}>
          {params.value}
        </span>
      )
    },
    {
      field: "inward_mode",
      headerName: "Mode",
      width: 100,
      renderCell: (params) => (
        <span style={{ fontWeight: params.row.isTotal ? 'bold' : 'normal', backgroundColor: params.row.isTotal ? '#fff3cd' : 'transparent', height: '100%', width: '100%', display: 'flex', alignItems: 'center' }}>
          {params.value}
        </span>
      )
    },
    {
      field: "inward_amount",
      headerName: "Amount in Rupees",
      width: 130,
      align: "right",
      headerAlign: "right",
      renderCell: (params) => {
        const val = params.value;
        const displayVal = val !== "" && val != null 
          ? parseFloat(val).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : "";
        return (
          <span style={{ fontWeight: params.row.isTotal ? 'bold' : 'normal', backgroundColor: params.row.isTotal ? '#fff3cd' : 'transparent', height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            {displayVal}
          </span>
        );
      }
    },
  ];

  const maxRecords = Math.max((totals.cash_outward_filtered || []).length, (totals.cash_inward_filtered || []).length);
  const gridData = Array.from({ length: maxRecords }).map((_, i) => {
    const outward = (totals.cash_outward_filtered || [])[i];
    const inward = (totals.cash_inward_filtered || [])[i];
    return {
      id: i,
      outward_details: outward ? outward.transaction_details : "",
      outward_mode: outward ? (outward.payment_mode || "") : "",
      outward_amount: outward ? outward.amount : "",
      inward_details: inward ? inward.transaction_details : "",
      inward_mode: inward ? (inward.payment_mode || "") : "",
      inward_amount: inward ? inward.amount : "",
      isTotal: false,
    };
  });

  if (maxRecords > 0) {
    gridData.push({
      id: "total_row",
      outward_details: "Total Expenses:",
      outward_mode: "",
      outward_amount: totals.cash_outward_total,
      inward_details: "",
      inward_mode: "",
      inward_amount: "",
      isTotal: true,
    });
    gridData.push({
      id: "balance_row",
      outward_details: "Current Balance:",
      outward_mode: "",
      outward_amount: totals.current_balance,
      inward_details: "",
      inward_mode: "",
      inward_amount: "",
      isTotal: true,
    });
    gridData.push({
      id: "grand_total_row",
      outward_details: "Total:",
      outward_mode: "",
      outward_amount: totals.cash_outward_total + totals.current_balance,
      inward_details: "Total:",
      inward_mode: "",
      inward_amount: totals.cash_inward_total,
      isTotal: true,
    });
  }

  return (
    <div className="pageBody">
      <ToastContainer />
      <Container fluid>
        <Card>
          <Card.Body>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col xs={12}>
                  <h6 className="commonSectionTitle">Daily Report</h6>
                </Col>
              </Row>

              <Row className="align-items-end">
                <Col xs={12} md={6} lg={4} xxl={4}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>
                        Select Date<span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        id="selected_date"
                        value={form.selected_date}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </div>
                </Col>

                <Col>
                  <div className="d-flex justify-content-end mt-4">
                    <Button
                      type="button"
                      variant="primary"
                      className="btn-info clearBtn me-3"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-success primaryBtn"
                      disabled={isLoading}
                    >
                      Submit
                    </Button>
                  </div>
                </Col>
              </Row>
            </form>
          </Card.Body>
        </Card>

        {(reportData.cash_inward?.length > 0 ||
          reportData.cash_outward?.length > 0) && (
            <>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <input
                  type="text"
                  placeholder="Search by transaction details..."
                  value={searchQuery}
                  className="form-control form-control-sm w-25"
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <div>
                  <Tooltip title="Export to Excel">
                    <Button
                      className="btnMain me-2"
                      variant="success"
                      onClick={exportToExcel}
                    >
                      <img
                        src={excelIcon}
                        alt="Download Excel"
                        style={{ width: "20px" }}
                      />
                    </Button>
                  </Tooltip>
                  <Tooltip title="Export to PDF">
                    <Button className="btnMain" variant="danger" onClick={exportToPDF}>
                      <FaFilePdf size={20} />
                    </Button>
                  </Tooltip>
                </div>
              </div>

              <div className="financeReportTableWrap mt-1">
                <div className="tableBody">
                  <Card className="border-0 shadow-none">
                    <Card.Body style={{ padding: 0 }}>
                      <Row className="g-2">
                        <Col md={12}>
                          <AppDataGrid
                            rows={gridData}
                            columns={gridColumns}
                            getRowId={(row) => row.id}
                            pageSizeOptions={[10, 20, 50]}
                            showToolbar={false}
                            pagination
                            density="compact"
                            maxHeight={550}
                          />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </>
          )}

        {!reportData.cash_inward?.length &&
          !reportData.cash_outward?.length &&
          form.selected_date &&
          !isLoading && (
            <Card className="mt-3">
              <Card.Body className="text-center text-muted">
                No data available for the selected date.
              </Card.Body>
            </Card>
          )}
      </Container>
    </div>
  );
};

export default Financedailyreport;
